import React, { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import axios from "../api/baseurl";
import "./Spinner.css";
import "./Loader.css";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import CreateAdminAccount from "./createAdminAccount";
import { toast } from "react-toastify";
import "./hm-theme.css";

function AdminDetails() {
  const [adminDetails, setAdminDetails] = useState([]);
  const [bioDetails, setBioDetails] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);

  const navigate = useNavigate();

  const getData = async () => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      const trans = await axios.get(`/api/accounts/role=ROLE_ADMIN`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setAdminDetails(trans.data || []);

      const bioDataPromises = (trans.data || []).map(async (admin) => {
        try {
          const accBio = await axios.get(`/api/account-bio/username=${admin.username}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          return { userId: admin.id, bio: accBio.data };
        } catch {
          return { userId: admin.id, bio: {} };
        }
      });

      const bioDataArray = await Promise.all(bioDataPromises);
      const bioDetailsMap = {};
      bioDataArray.forEach((bioData) => {
        bioDetailsMap[bioData.userId] = bioData.bio;
      });

      setBioDetails(bioDetailsMap);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const handleClick = (userid) => {
    navigate(`/users/admin-profile/${userid}`);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <Dashboard />
      {loader && <div className="loading"></div>}

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">

          {/* Page Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">admin_panel_settings</i>
                Admin Accounts
              </h2>
              <p className="hm-page-subtitle">Manage system administrator accounts and credentials</p>
            </div>
            <button className="btn-hm-primary" onClick={() => setIsModalOpen(true)}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>person_add</i>
              Add Admin Account
            </button>
          </div>

          {/* Admin Table Card */}
          <div className="hm-card">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">manage_accounts</i>
                Administrator Roster
              </h3>
              <span className="hm-badge hm-badge-primary">{adminDetails.length} accounts</span>
            </div>
            <div className="hm-card-body p-0">
              <div style={{ overflowX: "auto" }}>
                <table className="hm-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Email / Username</th>
                      <th>Full Name</th>
                      <th>Contact Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    {adminDetails.length === 0 ? (
                      <tr>
                        <td colSpan="4">
                          <div className="hm-empty-state">
                            <i className="material-icons">admin_panel_settings</i>
                            <p>{loader ? "Loading administrators..." : "No admin accounts found"}</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      adminDetails.map((admin, index) => {
                        const bio = bioDetails[admin.id] || {};
                        return (
                          <tr key={admin.id}>
                            <td>{index + 1}</td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-link p-0 fw-bold text-start text-decoration-none"
                                style={{ color: "#2f3a88" }}
                                onClick={() => handleClick(admin.id)}
                              >
                                {admin.username}
                              </button>
                            </td>
                            <td className="fw-semibold">
                              {bio.firstname || bio.lastname ? `${bio.firstname || ''} ${bio.lastname || ''}` : "—"}
                            </td>
                            <td>{bio.phone || "—"}</td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>

      {isModalOpen && (
        <CreateAdminAccount isOpen={isModalOpen} onRequestClose={handleCloseModal} />
      )}
    </div>
  );
}

export default AdminDetails;
